import { ObterDadosFormaPagamentoResposta } from "app/api/classes/OrcamentoApi";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";

declare var window:WindowMU

export function atualizarParcelasFormaPagamentoNoEstadoOrcamento(parcelas: ObterDadosFormaPagamentoResposta["Parcelas"], ElegivelParaCobrancaPIXaPrazo: boolean = null) 
{
    //window.orcamentoController.model.set("ParcelasFormaPagamento", parcelas)
    store.dispatch(sobrescreverInformacoesAction({ParcelasFormaPagamento: parcelas}))
   
    store.dispatch(sobrescreverInformacoesAction({ElegivelParaEmailCobrancaPixPrazo: ElegivelParaCobrancaPIXaPrazo}))
}